export const conversationsByCampaignId = /* GraphQL */ `
  query ConversationsByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationsByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        userId
        agentId
        campaignId
        twilioParticipantId
        twilioConversationId
        participantPhoneNumber
        participantFirstName
        participantLastName
        participantLinkedInProfile
        messagesCount
        isRead
        createdAt
        updatedAt
        user {
          id
          name
        }
        messages {
          items {
            id
            body
            createdAt
            updatedAt
            sender
          }
          nextToken
        }
        attachments {
          items {
            id
            media {
              twilioMediaSid
              contentType
              fileName
              classifiedDocumentType
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        pastOngoingConversationId
        isWebChatJoined
      }
      nextToken
    }
  }
`;

export const getConversationsByCampaignAndUpdatedAt = /* GraphQL */ `
  query GetConversationsByCampaignAndUpdatedAt(
    $campaignId: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getConversationsByCampaignAndUpdatedAt(
      campaignId: $campaignId
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        userId
        agentId
        campaignId
        participantPhoneNumber
        participantFirstName
        participantLastName
        participantEmailAddress
        participantLinkedInProfile
        messagesCount
        createdAt
        updatedAt
        isRead
        user {
          id
          name
        }
        attachments {
          items {
            id
            media {
              twilioMediaSid
              contentType
              fileName
              classifiedDocumentType
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        messages {
          items {
            id
            body
            createdAt
            updatedAt
            sender
          }
          nextToken
        }
        pastOngoingConversationId
        twilioRedirectConversationId
        twilioRedirectParticipantId
        twilioConversationId
        isWebChatJoined
        needsReview
        screeningQuestionsOutcome {
          screeningQuestion
          questionOutcome
          responseSummary
        }
        isHumanTakeover
        errorCode
        timeToFirstResponse
        timeToComplete
        completedAt
        sentAt
        repliesCount
        atsCandidateId
        atsApplicationId
        preferredAnswersScore
        openQuestionOutcomes {
          question
          responseSummary
          score
          openQuestionRequirementOutcomes {
            content
            isMet
            evidence
          }
        }
      }
      nextToken
    }
  }
`;

export const messagesByCampaignId = /* GraphQL */ `
  query MessagesByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        body
        status
        conversationId
        conversation {
          participantFirstName
          participantLastName
          participantLinkedInProfile
          participantPhoneNumber
        }
        agentId
        userId
        campaignId
        sender
        createdAt
        isInitial
        updatedAt
        twilioErrorCode
      }
      nextToken
    }
  }
`;

export const getMessagesByConversation = /* GraphQL */ `
  query GetMessagesByConversation(
    $conversationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getMessagesByConversation(
      conversationId: $conversationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        body
        status
        conversationId
        agentId
        userId
        campaignId
        sender
        createdAt
        isInitial
        updatedAt
        twilioErrorCode
        deliveredAt
        readAt
        templateId
        emailSubjectLine
        template {
          type
        }
        media {
          contentType
          twilioMediaSid
          fileName
          classifiedDocumentType
        }
      }
      nextToken
    }
  }
`;

export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      status
      userId
      agentId
      campaignId
      twilioParticipantId
      twilioConversationId
      participantPhoneNumber
      participantFirstName
      participantLastName
      participantLinkedInProfile
      participantEmailAddress
      messagesCount
      createdAt
      updatedAt
      isRead
      user {
        id
        name
      }
      attachments {
        items {
          id
          media {
            twilioMediaSid
            contentType
            fileName
            classifiedDocumentType
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      messages {
        items {
          id
          body
          createdAt
          updatedAt
          sender
        }
        nextToken
      }
      pastOngoingConversationId
      isWebChatJoined
      twilioRedirectConversationId
      twilioRedirectParticipantId
      screeningQuestionsOutcome {
        screeningQuestion
        questionOutcome
        responseSummary
      }
      errorCode
      needsReview
      isHumanTakeover
      timeToFirstResponse
      timeToComplete
      completedAt
      repliesCount
      atsCandidateId
      atsApplicationId
      preferredAnswersScore
      openQuestionOutcomes {
        question
        responseSummary
        score
        openQuestionRequirementOutcomes {
          content
          isMet
          evidence
        }
      }
    }
  }
`;

export const getConversationByParticipantPhoneNumberAndCampaignId = /* GraphQL */ `
  query GetConversationByParticipantPhoneNumberAndCampaignId(
    $participantPhoneNumber: AWSPhone!
    $campaignId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getConversationByParticipantPhoneNumberAndCampaignId(
      participantPhoneNumber: $participantPhoneNumber
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        userId
        agentId
        campaignId
        twilioParticipantId
        twilioConversationId
        candidateId
        participantPhoneNumber
        participantFirstName
        participantLastName
        participantLinkedInProfile
        messagesCount
        isRead
        createdAt
        updatedAt
        stage
        pastOngoingConversationId
      }
      nextToken
    }
  }
`;
export const getConversationsByStatusAndParticipantPhoneNumber = /* GraphQL */ `
  query GetConversationsByStatusAndParticipantPhoneNumber(
    $status: ConversationStatus!
    $participantPhoneNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getConversationsByStatusAndParticipantPhoneNumber(
      status: $status
      participantPhoneNumber: $participantPhoneNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        userId
        agentId
        campaignId
        twilioParticipantId
        twilioConversationId
        candidateId
        participantPhoneNumber
        participantFirstName
        participantLastName
        participantLinkedInProfile
        messagesCount
        isRead
        createdAt
        updatedAt
        stage
        pastOngoingConversationId
      }
      nextToken
    }
  }
`;
export const getConversationsByStatusAndTwilioConversationId = /* GraphQL */ `
  query GetConversationsByStatusAndTwilioConversationId(
    $status: ConversationStatus!
    $twilioConversationId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getConversationsByStatusAndTwilioConversationId(
      status: $status
      twilioConversationId: $twilioConversationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        userId
        agentId
        campaignId
        twilioParticipantId
        twilioConversationId
        candidateId
        participantPhoneNumber
        participantFirstName
        participantLastName
        participantLinkedInProfile
        messagesCount
        isRead
        createdAt
        updatedAt
        stage
        pastOngoingConversationId
        activeChannel
      }
      nextToken
    }
  }
`;

export const getAttachmentsByConversation = /* GraphQL */ `
  query GetAttachmentsByConversation(
    $conversationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAttachmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAttachmentsByConversation(
      conversationId: $conversationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationId
        media {
          twilioMediaSid
          contentType
          fileName
          classifiedDocumentType
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUnansweredQuestionsByConversation = /* GraphQL */ `
  query GetUnansweredQuestionsByConversation(
    $conversationId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUnansweredQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUnansweredQuestionsByConversation(
      conversationId: $conversationId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        summary
        isAnswered
        conversationId
        campaignId
        associatedMessageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
